import { createContext } from "react";

import useOpenTofuMigration from "./useOpenTofuMigration";

type OpenTofuMigrationContextProps = ReturnType<typeof useOpenTofuMigration>;

export const OpenTofuMigrationContext = createContext<OpenTofuMigrationContextProps | undefined>(
  undefined
);
OpenTofuMigrationContext.displayName = "OpenTofuMigrationContext";
